import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-number-background',
  templateUrl: './number-background.component.html',
  styleUrls: ['./number-background.component.scss']
})
export class NumberBackgroundComponent implements OnInit {

  @Input() backgroundImage : string;
  @Input() number : number;

  constructor() { }

  ngOnInit() {
  }

}
